// extracted by mini-css-extract-plugin
export default {"toggleSelector":"ToggleSelector_toggleSelector__zOW4h","wrapper":"ToggleSelector_wrapper__uyh+C","button":"ToggleSelector_button__+CW2F","active":"ToggleSelector_active__Mv5XM"};